/* mirror me：一覧の色の丸・カートボタン・選択画面（2026/11/04）
   ・商品が画面に入ったら、手が空いたときに色の写真と商品の情報を先に読み込んでおく
   ・色の丸：新しい写真の準備ができてから切り替える（真っ白にしない）。パソコンの2枚目の写真は外す */
(function(){
  if(window.__mmQA)return;window.__mmQA=1;
  var imgDone={},cache={},pending={};
  var idle=window.requestIdleCallback||function(f){return setTimeout(f,200);};
  function preImg(u){if(!u||imgDone[u])return imgDone[u];var i=new Image();i.decoding='async';i.src=u;imgDone[u]=i;return i;}
  function getJSON(url){
    if(cache[url])return Promise.resolve(cache[url]);
    if(pending[url])return pending[url];
    pending[url]=fetch(url+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){cache[url]=d;delete pending[url];var s=d.featured_image;if(s)preImg(s+(s.indexOf('?')>-1?'&':'?')+'width=240');return d;});
    return pending[url];
  }
  function warmCard(c){
    var ds=c.querySelectorAll('.mm-cs__dot');for(var i=0;i<ds.length;i++)preImg(ds[i].dataset.src);
    var b=c.querySelector('.mm-qa-btn');if(b)getJSON(b.dataset.url).catch(function(){});
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){io.unobserve(e.target);var t=e.target;idle(function(){warmCard(t);});}});},{rootMargin:'300px'});
    var watch=function(){var cs=document.querySelectorAll('.card-wrapper:not([data-mmw])');for(var i=0;i<cs.length;i++){if(cs[i].querySelector('.mm-cs,.mm-qa-btn')){cs[i].setAttribute('data-mmw','1');io.observe(cs[i]);}}};
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watch);}else{watch();}
    new MutationObserver(function(){idle(watch);}).observe(document.documentElement,{childList:true,subtree:true});
  }
  function early(e){
    var d=e.target.closest&&e.target.closest('.mm-cs__dot');if(d){preImg(d.dataset.src);return;}
    var c=e.target.closest&&e.target.closest('.card-wrapper');if(c&&!c.__mmw2){c.__mmw2=1;warmCard(c);}
    var b=e.target.closest&&e.target.closest('.mm-qa-btn');if(b){getJSON(b.dataset.url).catch(function(){});}
  }
  document.addEventListener('pointerdown',early,{passive:true});
  document.addEventListener('mouseover',early,{passive:true});
  document.addEventListener('click',function(e){
    var d=e.target.closest('.mm-cs__dot');if(!d)return;
    e.preventDefault();e.stopPropagation();
    var card=d.closest('.card-wrapper');if(!card)return;
    var on=card.querySelectorAll('.mm-cs__dot.is-on');for(var i=0;i<on.length;i++)on[i].classList.remove('is-on');
    d.classList.add('is-on');
    var img=card.querySelector('.card__media img');if(!img)return;
    var s=img.nextElementSibling;if(s&&s.tagName==='IMG'){s.parentNode.removeChild(s);}
    var u=d.dataset.src,n=preImg(u);
    var swap=function(){if(!d.classList.contains('is-on'))return;img.removeAttribute('srcset');img.removeAttribute('loading');img.src=u;};
    if(n&&n.complete){swap();}else if(n&&n.decode){n.decode().then(swap,swap);}else{swap();}
  });
  var sheet,body,cur=null;
  function money(c){return '¥'+Math.round(c/100).toLocaleString('ja-JP');}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function build(){
    if(sheet)return;
    sheet=document.createElement('div');sheet.className='mm-qa';sheet.hidden=true;
    sheet.innerHTML='<div class="mm-qa__bg" data-close></div><div class="mm-qa__panel" role="dialog" aria-modal="true" aria-label="カートに追加"><button type="button" class="mm-qa__x" data-close aria-label="閉じる"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg></button><div class="mm-qa__body"></div></div>';
    document.body.appendChild(sheet);body=sheet.querySelector('.mm-qa__body');
    sheet.addEventListener('click',function(e){if(e.target.closest('[data-close]'))close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!sheet.hidden)close();});
  }
  function open(){sheet.hidden=false;document.documentElement.style.overflow='hidden';void sheet.offsetWidth;sheet.classList.add('is-open');}
  function close(){sheet.classList.remove('is-open');document.documentElement.style.overflow='';setTimeout(function(){sheet.hidden=true;},200);}
  function find(p,sel){for(var i=0;i<p.variants.length;i++){var v=p.variants[i],ok=true;for(var j=0;j<sel.length;j++){if(v.options[j]!==sel[j]){ok=false;break;}}if(ok)return v;}return null;}
  function skeleton(card){
    var t=card&&card.querySelector('.card__heading a');var pr=card&&card.querySelector('.price-item--last,.price-item--regular');var im=card&&card.querySelector('.card__media img');
    body.innerHTML='<div class="mm-qa__head"><div class="mm-qa__img"><img alt="" src="'+(im?esc(im.currentSrc||im.src):'')+'"></div><div class="mm-qa__info"><p class="mm-qa__title"></p><p class="mm-qa__price"></p></div></div><div class="mm-qa__loading">読み込み中…</div>';
    body.querySelector('.mm-qa__title').textContent=t?t.textContent.trim():'';
    body.querySelector('.mm-qa__price').textContent=pr?pr.textContent.trim():'';
  }
  function render(p){
    cur={p:p,sel:[]};
    var first=null;for(var i=0;i<p.variants.length;i++){if(p.variants[i].available){first=p.variants[i];break;}}
    if(!first)first=p.variants[0];
    cur.sel=first.options.slice();
    var h='<div class="mm-qa__head"><div class="mm-qa__img"><img alt="" src=""></div><div class="mm-qa__info"><p class="mm-qa__title"></p><p class="mm-qa__price"></p></div></div>';
    if(!(p.variants.length===1&&p.variants[0].title==='Default Title')){
      for(var k=0;k<p.options.length;k++){
        var o=p.options[k];h+='<div class="mm-qa__opt"><p class="mm-qa__label">'+esc(o.name)+'<span class="mm-qa__val" data-val="'+k+'"></span></p><div class="mm-qa__vals">';
        for(var m=0;m<o.values.length;m++){h+='<button type="button" class="mm-qa__pill" data-o="'+k+'" data-v="'+esc(o.values[m])+'">'+esc(o.values[m])+'</button>';}
        h+='</div></div>';
      }
    }
    h+='<button type="button" class="mm-qa__add"></button><a class="mm-qa__link" href="'+p.url+'">商品の詳細を見る</a>';
    body.innerHTML=h;body.querySelector('.mm-qa__title').textContent=p.title;
    update();
  }
  function update(){
    var p=cur.p,v=find(p,cur.sel);
    var pills=body.querySelectorAll('.mm-qa__pill');
    for(var i=0;i<pills.length;i++){
      var b=pills[i],o=+b.dataset.o,val=b.dataset.v;
      b.classList.toggle('is-on',cur.sel[o]===val);
      var t=cur.sel.slice();t[o]=val;var tv=find(p,t);
      b.classList.toggle('is-out',!tv||!tv.available);
    }
    var vs=body.querySelectorAll('.mm-qa__val');for(var j=0;j<vs.length;j++){vs[j].textContent=cur.sel[+vs[j].dataset.val]||'';}
    var img=body.querySelector('.mm-qa__img img');
    var src=(v&&v.featured_image&&v.featured_image.src)||p.featured_image;
    if(src){img.src=src+(src.indexOf('?')>-1?'&':'?')+'width=240';}
    body.querySelector('.mm-qa__price').textContent=v?money(v.price):'';
    var add=body.querySelector('.mm-qa__add');
    if(v&&v.available){add.disabled=false;add.textContent='カートに追加する';add.dataset.id=v.id;}
    else{add.disabled=true;add.textContent=v?'売り切れ':'お選びください';add.removeAttribute('data-id');}
    if(p.variants){for(var n=0;n<p.variants.length;n++){var fv=p.variants[n].featured_image;if(fv&&fv.src)preImg(fv.src+(fv.src.indexOf('?')>-1?'&':'?')+'width=240');}}
  }
  function addToCart(a){
    a.disabled=true;a.textContent='追加しています…';
    var drawer=document.querySelector('cart-drawer');
    var fd=new FormData();fd.append('id',a.dataset.id);fd.append('quantity',1);
    if(drawer&&drawer.getSectionsToRender){fd.append('sections',drawer.getSectionsToRender().map(function(s){return s.id;}));fd.append('sections_url',window.location.pathname);}
    fetch((window.routes&&window.routes.cart_add_url||'/cart/add')+'.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},body:fd})
    .then(function(r){return r.json();}).then(function(res){
      if(res.status){a.textContent=res.description||'追加できませんでした';setTimeout(function(){a.disabled=false;update();},1800);return;}
      close();
      if(drawer&&drawer.renderContents){drawer.classList.remove('is-empty');drawer.renderContents(res);}else{location.href='/cart';}
    }).catch(function(){location.href='/cart';});
  }
  document.addEventListener('click',function(e){
    var p=e.target.closest('.mm-qa__pill');
    if(p&&cur){cur.sel[+p.dataset.o]=p.dataset.v;update();return;}
    var a=e.target.closest('.mm-qa__add');
    if(a&&a.dataset.id&&!a.disabled){addToCart(a);return;}
    var q=e.target.closest('.mm-qa-btn');
    if(q){e.preventDefault();e.stopPropagation();build();var url=q.dataset.url;
      if(cache[url]){render(cache[url]);open();return;}
      skeleton(q.closest('.card-wrapper'));open();
      getJSON(url).then(render).catch(function(){location.href=url;});
    }
  });
})();
